import React, { createContext, useContext, useEffect, useMemo, useState } from "react";
import { cartLineTotal } from "@/lib/api";

const CartContext = createContext(null);
const KEY = "uk_cart_v1";

export function CartProvider({ children }) {
    const [lines, setLines] = useState(() => {
        try {
            const raw = localStorage.getItem(KEY);
            return raw ? JSON.parse(raw) : [];
        } catch (_) {
            return [];
        }
    });
    const [open, setOpen] = useState(false);

    useEffect(() => {
        localStorage.setItem(KEY, JSON.stringify(lines));
    }, [lines]);

    const addLine = (line) => {
        setLines((prev) => [...prev, { ...line, quantity: line.quantity || 1 }]);
        setOpen(true);
    };

    const updateQty = (index, qty) => {
        setLines((prev) =>
            prev.map((l, i) => (i === index ? { ...l, quantity: Math.max(1, qty) } : l))
        );
    };

    const removeLine = (index) => setLines((prev) => prev.filter((_, i) => i !== index));
    const clear = () => setLines([]);

    const subtotal = useMemo(
        () => lines.reduce((s, l) => s + cartLineTotal(l), 0),
        [lines]
    );
    const count = useMemo(
        () => lines.reduce((s, l) => s + Number(l.quantity || 1), 0),
        [lines]
    );

    return (
        <CartContext.Provider
            value={{ lines, addLine, updateQty, removeLine, clear, subtotal, count, open, setOpen }}
        >
            {children}
        </CartContext.Provider>
    );
}

export const useCart = () => useContext(CartContext);
